import React, { useContext } from "react";
import ContentPage from "components/contentPage/ContentPage";
import { BranchFavouriteContext } from "contexts/BranchFavouriteContext";
import { IBranch } from "types/Branch";
import styles from "./StockTransfers.module.css";
import {
  BranchSelector,
  IBranchSelectorProps,
} from "components/branchSelector/BranchSelector";
import {
  MaterialContext,
  IMaterialContextInterface,
} from "contexts/MaterialsContext";
import { StockTransferTable } from "components/stockTransferTable/StockTransferTable";
import { useLocalBranch } from "hooks/LocalStorage";
import { AddStockTransferModal } from "components/addStockTransferModal/AddStockTransferModal";
import { ModalWithButton } from "components/modalWithButton/ModalWithButton";
import { AddFavouriteModalHelper } from "components/addFavouriteModalHelper/AddFavouriteModalHelper";
import { AddFavouritesModal } from "components/addFavouritesModal/AddFavouritesModal";
import { FavouriteEntity } from "types/Favourite";
import { getSettings } from "api/GetSettings";
import StockTransferIcon from "assets/StockTransferIcon";

const StockTransfers: React.FC = React.memo(() => {
  const { branches } = useContext(BranchFavouriteContext);
  const materialContextValues = useContext(MaterialContext);
  const [selectedBranch, setSelectedBranch] = useLocalBranch(
    branches.length > 0 ? branches[0] : undefined
  );

  // // TODO handle no branches error
  if (!selectedBranch || materialContextValues.fetchingStatus !== "completed") {
    return <></>;
  }
  return (
    <ContentPage
      header={
        <Header
          branches={branches!}
          selectedBranch={selectedBranch}
          setSelectedBranch={setSelectedBranch}
        />
      }
      mainContent={<MainSection selectedBranch={selectedBranch} />}
      rightSection={
        <RightSection
          materialContextValues={
            materialContextValues.branchWiseMaterialsMap.get(selectedBranch.id)!
          }
          selectedBranch={selectedBranch}
        />
      }
    />
  );
});

const Header: React.FC<IBranchSelectorProps> = (props) => (
  <>
    <div className={styles.pageName}>{"In-flow / Out-flow"}</div>
    <BranchSelector {...props} />
  </>
);

const MainSection: React.FC<{ selectedBranch: IBranch }> = (props) => (
  <>
    <StockTransferTable selectedBranch={props.selectedBranch} />
  </>
);

const RightSection: React.FC<{
  materialContextValues: IMaterialContextInterface;
  selectedBranch: IBranch;
}> = (props) => (
  <>
    <ModalWithButton title={"Add Stock Out"} icon={<StockTransferIcon />}>
      {" "}
      <AddStockTransferModal
        materialContextValues={props.materialContextValues}
        selectedBranch={props.selectedBranch}
      />{" "}
    </ModalWithButton>
    <AddFavouriteModalHelper>
      {" "}
      <AddFavouritesModal
        selectedBranch={props.selectedBranch}
        materials={
          props.materialContextValues?.allMaterialsArrForFoodAnalysis ?? []
        }
        favouriteEntity={FavouriteEntity.STOCK_TRANSFER}
        onClose={getSettings}
      />{" "}
    </AddFavouriteModalHelper>
  </>
);

export default StockTransfers;
